.header {
  position: relative;
  z-index: 2;
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--space-12);
  min-height: var(--w-header);
  padding: var(--space-12) var(--space-8) var(--space-12) var(--space-16);
  padding-top: max(var(--space-12), var(--safe-top));
  background: var(--w-bg);
  box-shadow: 0 1px 0 transparent;
  transition: box-shadow 160ms ease;
}

.header[data-scrolled] {
  box-shadow: 0 1px 0 var(--w-border);
}

.logo,
.monogram {
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

/* Logos are drawn for a light background: a white tile in both themes, with
   room around the mark and a hairline so it does not melt into the header. */
.logo {
  padding: 5px;
  object-fit: contain;
  background: var(--w-logo-bg);
  box-shadow: inset 0 0 0 1px var(--w-border);
}

.monogram {
  display: grid;
  place-items: center;
  background: var(--w-accent);
  color: var(--w-on-accent);
  font-size: 16px;
  font-weight: 650;
}

.logo[data-size="lg"],
.monogram[data-size="lg"] {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  font-size: 20px;
}

.logo[data-size="lg"] {
  padding: 7px;
}

.titles {
  flex: 1;
  min-width: 0;
}

.name,
.subtitle {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name {
  font-size: 15px;
  font-weight: 650;
  line-height: 1.3;
  letter-spacing: -0.005em;
}

.subtitle {
  color: var(--w-muted);
  font-size: 13px;
  line-height: 1.35;
}

.actions {
  display: flex;
  gap: var(--space-2);
}

.action {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: var(--w-muted);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease, transform 120ms var(--ease-out);
}

.action :global(.icon) {
  width: 20px;
  height: 20px;
}

.action:active {
  transform: scale(0.94);
  background: var(--w-press);
}

@media (hover: hover) and (pointer: fine) {
  .action:hover {
    background: var(--w-hover);
    color: var(--w-text);
  }
}

/* Full screen on a phone the header is the sheet's handle (sheet-drag.ts):
   the grabber says it can be pulled down, and the browser must not take the
   vertical drag for itself. */
.grabber {
  display: none;
}

:global(:root[data-fullscreen]) .grabber {
  position: absolute;
  top: max(5px, calc(var(--safe-top) - 8px));
  left: 50%;
  display: block;
  width: 36px;
  height: 5px;
  border-radius: 3px;
  background: var(--w-border-strong);
  translate: -50% 0;
  pointer-events: none;
}

:global(:root[data-fullscreen]) .header {
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

/* Full screen on a phone the chat closes downwards, like a sheet; as a panel it closes with ✕. */
.fullscreenOnly {
  display: none !important;
}

:global(:root[data-fullscreen]) .fullscreenOnly {
  display: inline-flex !important;
}

:global(:root[data-fullscreen]) .panelOnly {
  display: none !important;
}
